"use client";

import { ReactNode } from "react";
import { useRouter } from "next/navigation";
import {
  selectIsAuthSuccessOrPerpetual,
  store,
  setIsCommonSsoModalVisible,
  useAppSelector,
} from "@repo/web-store";
import { stringToBoolean } from "@repo/shared-utils/pwa-utils";
import { handleRedirection } from "../../utils/helper";
import {
  trackDiscoverStocksCarouselClick,
  type ServiceSectionCtConfig,
} from "./discoverStocksCt";

interface ServiceSectionCtCardProps {
  url: string;
  inNewTab?: string;
  headerName?: string;
  ctaText: string;
  isLoginRequired: string;
  sectionTitle: string;
  analyticsConfig?: ServiceSectionCtConfig;
  children: ReactNode;
}

export default function ServiceSectionCtCard({
  url,
  inNewTab,
  headerName,
  ctaText,
  isLoginRequired,
  sectionTitle,
  analyticsConfig,
  children,
}: Readonly<ServiceSectionCtCardProps>) {
  const router = useRouter();
  const isAuthSuccessOrPerpetual = useAppSelector(selectIsAuthSuccessOrPerpetual);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (stringToBoolean(isLoginRequired) && !isAuthSuccessOrPerpetual) {
      store.dispatch(setIsCommonSsoModalVisible(true));
      return;
    }

    void trackDiscoverStocksCarouselClick({
      sectionTitle,
      ctaText,
      destinationUrl: url,
      analyticsConfig,
    });

    const args: (string | undefined)[] = [];
    if (inNewTab) args.push(inNewTab);
    if (headerName) args.push(headerName);
    handleRedirection(url, router, ...(args as [string | undefined, string | undefined]));
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- wrapper uses display:contents; same pattern as RedirectionHandler
    <div
      onClick={handleClick}
      className="contents"
    >
      {children}
    </div>
  );
}
